export default "__VITE_ASSET__f53dabe5__"